import { createContext } from 'react';

interface ListPropertiesContextProps {
  highListName?: string;
  isNestedList?: boolean;
}

export const ListPropertiesContext = createContext<ListPropertiesContextProps>(
  {},
);

export default ListPropertiesContext;
